var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full inline-block text-center py-4 cursor-pointer font-medium rounded text-white focus:outline-none",class:[_vm.bg]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }